import React from 'react'
import { connect } from 'react-redux';

import ActionButtons from '../../commons/ActionButtons'
import Checkbox from '../../commons/Checkbox'

import { updateDeclarationStart } from '../../../actions';

class Declarations extends React.Component {
  state = {
    errors: {},
    extendedLeave: null,
    existingLoan: null,
    employmentChange: null,
    expenditure: null,
    continueEnabled: true,
  }

  componentDidMount() {
    window.scrollTo({top: 0})
  }

  componentWillMount() {
    this.setState({
      extendedLeave: this.props.declaration.extendedLeave,
      existingLoan: this.props.declaration.existingLoan,
      employmentChange: this.props.declaration.employmentChange,
      expenditure: this.props.declaration.expenditure,
    })
  }

  onContinueClick = () => {
    this.setState({
      continueEnabled: false
    })

    this.props.updateDeclarationStart({
      declaration: {
        extendedLeave: this.state.extendedLeave,
        existingLoan: this.state.existingLoan,
        employmentChange: this.state.employmentChange,
        expenditure: this.state.expenditure,
      }
    })
  }

  handleCheckbox = (e) => {
    this.setState({ [e.target.id]: e.target.checked })
  }

  render() {
    const {
      continueEnabled,
      extendedLeave,
      existingLoan,
      employmentChange,
      expenditure
    } = this.state

    return(
      <div>
        <h3>Declarations</h3>
        <p className='grey big mb-4'>Please consider these potential changes to your financial situation in the next 3 years. If none apply, please continue.</p>
        <div className='card card-single'>
          <div className='card-header'>
            Select any that apply
          </div>
          <div className='list-group list-group-flush'>
            <div className='list-group-item'>
              <Checkbox
                id='extendedLeave'
                text= { I18n.t('loan_application_user.declaration.extended_leave') }
                onClick={ this.handleCheckbox }
                checked={ extendedLeave }
              />
            </div>
            <div className='list-group-item'>
              <Checkbox
                id='existingLoan'
                text= {I18n.t( 'loan_application_user.declaration.existing_loan') }
                onClick={ this.handleCheckbox }
                checked={ existingLoan }
              />
            </div>
            <div className='list-group-item'>
              <Checkbox
                id='employmentChange'
                text= {I18n.t( 'loan_application_user.declaration.employment_change') }
                onClick={ this.handleCheckbox }
                checked={ employmentChange }
              />
            </div>
            <div className='list-group-item'>
              <Checkbox
                id='expenditure'
                text= {I18n.t( 'loan_application_user.declaration.expenditure') }
                onClick={ this.handleCheckbox }
                checked={ expenditure }
              />
            </div>
          </div>
        </div>
        <ActionButtons
          continueEnabled={ continueEnabled }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  declaration: state.declaration,
})

export default connect(mapStateToProps, {
  updateDeclarationStart,
})(Declarations)
